import { render, staticRenderFns } from "./special_list_hfwl.vue?vue&type=template&id=a628a978&scoped=true"
import script from "./special_list_hfwl.vue?vue&type=script&lang=js"
export * from "./special_list_hfwl.vue?vue&type=script&lang=js"
import style0 from "./special_list_hfwl.vue?vue&type=style&index=0&id=a628a978&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a628a978",
  null
  
)

export default component.exports